import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export var ConditionalWrapper = _ref => {
  var {
    condition,
    wrapper,
    children
  } = _ref;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: condition ? wrapper(children) : children
  });
};
ConditionalWrapper.displayName = 'ConditionalWrapper';
//# sourceMappingURL=ConditionalWrapper.js.map